module.exports = __webpack_public_path__ + "static/media/partners.8378100f.png";